import { Component, Host, Prop, h } from '@stencil/core';

import actions from '../../../actions/actions.offer';

const MIN_ALLOWED_INTERVAL = 1000; // Let's not accidentally ddos with offer-refresh

@Component({
  tag: 'offer-refresh',
})
export class OfferRefresh {
  @Prop() offerId: string = '';
  @Prop() interval?: number = 5000;
  @Prop() isActive?: boolean;

  private intervalId;

  componentWillLoad() {
    if (this.isActive) {
      this.intervalId = setInterval(
        () => {
          actions.onOfferFetch(this.offerId);
        },
        Math.max(this.interval, MIN_ALLOWED_INTERVAL)
      );
    }
  }

  disconnectedCallback() {
    clearInterval(this.intervalId);
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
